var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"hidden","name":_vm.p_surveyItem.surveyItemKey},domProps:{"value":_vm.p_objValues[_vm.p_surveyItem.surveyItemKey]}})}
var staticRenderFns = []

export { render, staticRenderFns }